import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Agent } from './models/agent.model';  
import { LocalStorage } from './util/localstorage.service';
import { NavigationEnd, Router } from '@angular/router';
import { RouteUtil } from './util/route-util';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent {
	title = 'longevity';
	public loggedAgent: Agent 

	constructor(public translate: TranslateService,private router: Router) {
		translate.addLangs(['en', 'fr'])
		translate.setDefaultLang('en')
		const browserLang = translate.getBrowserLang()
		translate.use(browserLang.match(/en|fr/) ? browserLang : 'en')
		var pathName: string = window.location.pathname.replace('/', '');
		
	}
	ngOnInit(): void {
		this.checkLoginStatus();
	  }
	  private checkLoginStatus(): void {
		const loggedAgent = JSON.parse(localStorage.getItem(LocalStorage.LOGGED_AGENT))
		if (loggedAgent === null) {
		  this.router.navigateByUrl('/');  
		}
	  }
}
